import useDayJs from '@/composables/useDayJs.js'

export async function getActivityLog(t, items) {
  const grouped = {}
  const translationPath = 'utils.getActivityLog'

  items
    .sort((a, b) => useDayJs(b.dateTime).valueOf() - useDayJs(a.dateTime).valueOf())
    .forEach((item) => {
      const date = useDayJs(item.dateTime)

      let key, title

      if (date.isToday()) {
        key = 'today'
        title = t(`${translationPath}.today`)
      } else if (date.isYesterday()) {
        key = 'yesterday'
        title = t(`${translationPath}.yesterday`)
      } else if (useDayJs().diff(date, 'day') <= 6) {
        key = date.format('dddd').toLowerCase()
        title = t(`${translationPath}.days.${key}`)
      } else {
        const monthKey = date.format('MMMM').toLowerCase()
        const translatedMonth = t(`${translationPath}.months.${monthKey}`)
        key = date.format('D MMMM YYYY') // used for sorting
        title = `${date.format('D')} ${translatedMonth} ${date.format('YYYY')}`
      }

      // Ensure the group exists with metadata
      if (!grouped[key]) {
        grouped[key] = {
          key,
          title,
          items: [],
        }
      }

      grouped[key].items.push({
        variant: item.variant,
        icon: item.icon,
        time: useDayJs(item.dateTime).format('LT'),
        title: item.title,
        name: item.name,
        rows: item.rows,
      })
    })

  const weekOrder = [
    'today',
    'yesterday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]

  return Object.values(grouped).sort((a, b) => {
    const indexA = weekOrder.indexOf(a.key)
    const indexB = weekOrder.indexOf(b.key)

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB
    }

    if (indexA !== -1) return -1
    if (indexB !== -1) return 1

    return useDayJs(b.items[0].time).valueOf() - useDayJs(a.items[0].time).valueOf()
  })
}
